"use client";

// ============================================
// Topbar — top navigation bar
// ============================================

export type TabName = "dossier" | "opportunities" | "slack" | "support" | "retention";

interface TopbarProps {
  currentTab: TabName;
  onTabChange: (tab: TabName) => void;
  onSearchOpen: () => void;
}

const TABS: { name: TabName; label: string; badge?: boolean }[] = [
  { name: "dossier", label: "Dossier" },
  { name: "opportunities", label: "Opportunities", badge: true },
  { name: "slack", label: "Slack Asks" },
  { name: "support", label: "Support" },
  { name: "retention", label: "Retention" },
];

export default function Topbar({ currentTab, onTabChange, onSearchOpen }: TopbarProps) {
  return (
    <header className="topbar">
      <div className="topbar-brand">
        <span className="topbar-logo">Founders Club</span>
        <span className="topbar-divider"></span>
        <span className="topbar-subtitle">Community Intelligence</span>
      </div>
      <nav className="topbar-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.name}
            className={`topbar-tab${currentTab === tab.name ? " active" : ""}`}
            data-tab={tab.name}
            onClick={() => onTabChange(tab.name)}
          >
            {tab.label}
            {tab.badge && <span className="tab-badge"></span>}
          </button>
        ))}
      </nav>
      <div className="topbar-right">
        <button className="topbar-search-trigger" onClick={onSearchOpen}>
          Search members... <kbd>/</kbd>
        </button>
      </div>
    </header>
  );
}
